import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Pis.css';
import Right from '../../right/Right';
import Service from '../../service/Service';

const service = new Service();

class PisInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialData: [],
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
    }

    componentDidMount() { }

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools/pregnancy-checkup-schedule")} className="R11_9e">Pregnancy Inspection Schedule</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>How to Use</span>
                    </div>
                    <h1 className="B24_00">How to Use</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="pregnancy-schedule">
                            <div className="schedule">
                                <div className="schedule-title M18_42">Your complete guide to Prenatal Testing</div>
                                <div className="disclaimer-content">
                                    <span className="R14_61">
                                        <p>Over the next nine months, you will see your OB at least 10 times. It is quite important to see how your body is functioning during pregnancy and ensure you and the baby are healthy. It is also very important to follow the tests in a timely manner. If you are ever unsure about a test schedule refer “pregnancy Inspection Schedule” tool. </p>
                                        <p>This tool gives you a top level overview of prenatal tests from conception to birth, approximately when they happen and made easier for you to determine the dates of tests in the timely manner relevant to your pregnancy up to 40 weeks.</p>
                                        <p>The pregnancy inspection schedule gives you a quick overview of where you are in your pregnancy.</p>
                                        <p>Pregnancy is divided into 3 trimesters as week 1 to 13 as&nbsp;first trimester, 13 to 27 as second and 28 to delivery as&nbsp;third.</p>
                                        <p>This tool notifies you about the test which are due or upcoming. It helps you to manage custom reminders, update test details for your future reference.</p>
                                    </span>
                                    <span className="M14_42">Disclaimer</span>
                                    <span>
                                        <p>The schedule used for Pregnancy Inspection Schedule provides recommended dates based on expecting mothers due date. Please consult your gynecologist before taking any action. This is not an official inspection records.</p>
                                    </span>
                                    <span className="M14_42"> Reference:</span>
                                    <span>
                                        <p> American Pregnancy <br />
                                            <a href={"http://americanpregnancy.org/prenatal-testing/"} className="R14_link">(http://americanpregnancy.org/prenatal-testing/)</a><br />
                                        </p>
                                        <p>Healthline<br />
                                            <a href={"https://www.healthline.com/health/pregnancy/prenatal-testing#first-trimester"} className="R14_link">(https://www.healthline.com/health/pregnancy/prenatal-testing#first-trimester)</a>
                                        </p>
                                        <p>The Bump<br />
                                            <a href={"https://www.thebump.com/a/prenatal-tests-checklist"} className="R14_link">(https://www.thebump.com/a/prenatal-tests-checklist)</a>
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default PisInfo;



// WEBPACK FOOTER //
// src/shared/tools/pis/PisInfo.js